import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import {
  deleteRoleAssignFailed,
  deleteRoleAssignSuccess,
  DELETE_ROLE_ASSIGN_START,
} from '~/modules/configuration/redux/actions/role-list'
import { api } from '~/services/api'
import addNotification from '~/utils/toast'

const deleteRoleAssignApi = (params) => {
  const uri = `/users/user-role-settings/${params}`
  return api.delete(uri)
}

const deleteRoleMultipleApi = (params) => {
  const uri = `/users/user-role-settings/multiple`
  return api.delete(uri, params)
}

function* doDeleteRoleAssign(action) {
  try {
    const response = yield call(
      action.payload?.codes ? deleteRoleMultipleApi : deleteRoleAssignApi,
      action?.payload,
    )

    if (response?.statusCode === 200) {
      yield put(deleteRoleAssignSuccess(response.results))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }

      addNotification(
        'roleManagement.notification.deleteSuccess',
        NOTIFICATION_TYPE.SUCCESS,
      )
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(deleteRoleAssignFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError()
    }
  }
}

export default function* watchDeleteRoleAssign() {
  yield takeLatest(DELETE_ROLE_ASSIGN_START, doDeleteRoleAssign)
}
